import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export function useFitnetStatus() {
  const [isAvailable, setIsAvailable] = useState(null); // null = not checked yet
  const [loading, setLoading] = useState(true);
  const [lastCheck, setLastCheck] = useState(null);

  const checkStatus = useCallback(async () => {
    console.log('[FitnetStatus] Checking status...');
    try {
      const response = await axios.get(`${API}/api/fitnet-status`, { timeout: 5000 });
      console.log('[FitnetStatus] Response:', response.data);
      setIsAvailable(response.data?.available ?? false);
      setLastCheck(new Date());
    } catch (error) {
      console.error('[FitnetStatus] Check failed:', error);
      setIsAvailable(false);
    } finally {
      console.log('[FitnetStatus] Setting loading to false');
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkStatus();
    
    // Check every 30 seconds
    const interval = setInterval(checkStatus, 30000);
    
    return () => clearInterval(interval);
  }, [checkStatus]);

  return { isAvailable, loading, lastCheck, refresh: checkStatus };
}

export default useFitnetStatus;
